import { render } from "./EditDoctor.vue?vue&type=template&id=831eb668&scoped=true"
import script from "./EditDoctor.vue?vue&type=script&lang=js"
export * from "./EditDoctor.vue?vue&type=script&lang=js"

import "./EditDoctor.vue?vue&type=style&index=0&id=831eb668&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-831eb668"]])

export default __exports__